export const MUSIC_GENRES = [
  { id: "Pop", label: "🎵 Pop" },
  { id: "Rock / Metal", label: "🤘 Rock / Metal" },
  { id: "Electronic / Techno", label: "🎧 Electronic / Techno" },
  { id: "Jazz / Blues", label: "🎷 Jazz / Blues" },
  { id: "Hip-Hop / R&B", label: "🎤 Hip-Hop / R&B" },
  { id: "Klassik", label: "🎻 Klassik" },
  { id: "Latin / Salsa", label: "🪗 Latin / Salsa" },
  { id: "World Music", label: "🌍 World Music" },
  { id: "Indie / Alternative", label: "🎸 Indie / Alternative" },
  { id: "Funk / Soul", label: "🎺 Funk / Soul" },
  { id: "Comedy", label: "🎭 Comedy" },
] as const;

export type MusicGenre = (typeof MUSIC_GENRES)[number]["id"];

export const GENRE_EMOJI: Record<MusicGenre, string> = {
  Pop: "🎵",
  "Rock / Metal": "🤘",
  "Electronic / Techno": "🎧",
  "Jazz / Blues": "🎷",
  "Hip-Hop / R&B": "🎤",
  Klassik: "🎻",
  "Latin / Salsa": "🪗",
  "World Music": "🌍",
  "Indie / Alternative": "🎸",
  "Funk / Soul": "🎺",
  Comedy: "🎭",
};

export const MUSIC_GENRE_IDS: MusicGenre[] = MUSIC_GENRES.map((g) => g.id);

export function genreDisplayLabel(genre: MusicGenre): string {
  return MUSIC_GENRES.find((g) => g.id === genre)?.label ?? genre;
}

export function genreEmojiLabel(genre: MusicGenre): string {
  return `${GENRE_EMOJI[genre] ?? "🎵"} ${genre}`;
}

export function genreShortLabel(genre: MusicGenre): string {
  return genre;
}
